import { useState, useEffect, useContext, useCallback } from "react"

import { AnimatedWindowCallbackContext } from "context/window/AnimatedWindowProvider"
import server from "server/serverController2"

import DaumPostCode from "components/containers/common/DaumPostCode"

const useShippingAddressForm = ({ onComplete }) => {
  const { openWindow, closeWindow, id } = useContext(AnimatedWindowCallbackContext)

  const [address, setAddress] = useState(null)
  const [zipcode, setZipcode] = useState("")
  const [sido, setSido] = useState("")
  const [sigungu, setSigungu] = useState("")
  const [dongri, setDongri] = useState("")
  const [shippingAction, setShippingAction] = useState(null)
  const [isValid, setIsValid] = useState(false)
  const [values, setValues] = useState({
    recipient: "",
    phone: "",
    shippingDetail: "",
    detailAddress: "",
  })

  const handleCompleteSearchAddress = useCallback(
    (data) => {
      const { zonecode, address, sido, sigungu, bname } = data
      closeWindow(id)
      setZipcode(zonecode)
      setAddress(address)
      setSido(sido)
      setSigungu(sigungu)
      setDongri(bname)
    },
    [closeWindow, id]
  )

  const handleChangeShippingOption = (data) => {
    setShippingAction(data)
  }

  const openSearchForm = useCallback(() => {
    openWindow({
      id: id,
      Component: <DaumPostCode onComplete={handleCompleteSearchAddress} />,
      headerProps: {
        title: "주소검색",
      },
    })
  }, [handleCompleteSearchAddress, id, openWindow])

  const handleChange = (e) => {
    const { value, name } = e.target

    setValues((values) => ({ ...values, [name]: value }))
  }

  const handleSubmit = useCallback(async () => {
    const { recipient, phone, detailAddress, shippingDetail } = values
    try {
      const body = {
        recipient,
        phone,
        address1: address,
        address2: detailAddress,
        zipcode,
        sido,
        sigungu,
        dongri,
        ...(shippingAction && {
          shipping_action: shippingAction.value === "etc" ? shippingDetail : shippingAction.label,
        }),
        is_default: true,
      }

      const response = await server.postRequestData(`users/shippings`, body)
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }

      const { inserted_item: userShippingAddress } = response.data
      if (onComplete) onComplete(userShippingAddress)
    } catch (error) {}
  }, [address, dongri, onComplete, shippingAction, sido, sigungu, values, zipcode])

  useEffect(() => {
    const { recipient, phone, detailAddress } = values
    if (
      ![recipient, phone, detailAddress].includes("") &&
      ![null, undefined].includes(zipcode) &&
      ![null, undefined].includes(address)
    ) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [address, values, zipcode])

  return {
    address,
    zipcode,
    shippingAction,
    isValid,
    openSearchForm,
    handleChangeShippingOption,
    handleChange,
    handleSubmit,
  }
}

export default useShippingAddressForm
